import { createBlock } from '@core/utils/createBlock';

// Compatible with older versions
export const createCustomBlock = createBlock;
